export default __webpack_public_path__ + "static/media/header-1.21ce95d6.jpg";